module.exports = __webpack_public_path__ + "img/kefu.e429cd71.png";